import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SolucoesCrossLink from "@/components/feature/SolucoesCrossLink";
import CriaSiteHero from "@/pages/sites/components/CriaSiteHero";
import PreviewExplainer from "@/pages/sites/components/PreviewExplainer";
import Deliverables from "@/pages/sites/components/Deliverables";
import PreviewForm from "@/pages/sites/components/PreviewForm";
import HowItWorks from "@/pages/sites/components/HowItWorks";
import CustomReasons from "@/pages/sites/components/CustomReasons";
import SpeedSection from "@/pages/sites/components/SpeedSection";
import SeoSection from "@/pages/sites/components/SeoSection";
import ConversionSection from "@/pages/sites/components/ConversionSection";
import SiteFeatures from "@/pages/sites/components/SiteFeatures";
import SiteKinds from "@/pages/sites/components/SiteKinds";
import AudienceSection from "@/pages/sites/components/AudienceSection";
import Differentials from "@/pages/sites/components/Differentials";
import BeforeAfter from "@/pages/sites/components/BeforeAfter";
import PortfolioSection from "@/pages/sites/components/PortfolioSection";
import SiteCases from "@/pages/sites/components/SiteCases";
import LogoPortfolio from "@/pages/sites/components/LogoPortfolio";
import TechFlow from "@/pages/sites/components/TechFlow";
import CriaSiteFinalCta from "@/pages/sites/components/CriaSiteFinalCta";
import { criacaoFaqs } from "@/mocks/criacao-sites";

export default function Sites() {
  return (
    <SiteLayout>
      <Seo
        title="Criação de Sites Profissionais | Prévia Sem Custo | NXHOST"
        description="Criação de sites profissionais, modernos, rápidos e responsivos. Solicite uma prévia inicial sem custo e veja uma proposta para sua empresa antes de contratar."
        keywords="criação de sites, criação de site profissional, desenvolvimento de sites, site para empresas, criação de site empresarial, site responsivo, site otimizado para SEO, site institucional, criação de landing page, criação de loja virtual, criação de logotipo"
        path="/sites"
        titleEn="Professional Website Creation | Free Preview | NXHOST"
        titleEs="Creación de Sitios Web Profesionales | Vista Previa Sin Costo | NXHOST"
        descriptionEn="Professional, modern, fast and responsive website creation. Request a free initial preview and see a proposal for your company before hiring."
        descriptionEs="Creación de sitios web profesionales, modernos, rápidos y responsivos. Solicita una vista previa inicial sin costo y conoce una propuesta antes de contratar."
        faqs={criacaoFaqs}
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Criação de Sites", path: "/sites" },
        ]}
      />

      <CriaSiteHero />
      <PreviewExplainer />
      <Deliverables />
      <PreviewForm />
      <HowItWorks />
      <CustomReasons />
      <SpeedSection />
      <SeoSection />
      <ConversionSection />
      <SiteFeatures />
      <SiteKinds />
      <AudienceSection />
      <Differentials />
      <BeforeAfter />
      <PortfolioSection />
      <SiteCases />
      <LogoPortfolio />
      <TechFlow />

      <section className="bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <SectionHeading
            badge="Perguntas frequentes"
            badgeIcon="ri-question-line"
            title="Perguntas frequentes"
            description="Tire as principais dúvidas sobre a criação do seu site com a NXHOST."
          />
          <div className="mt-12">
            <FaqAccordion items={criacaoFaqs} />
          </div>
        </div>
      </section>

      <SolucoesCrossLink
        title="Vá além do seu site"
        description="Um site profissional é o primeiro passo. A NXHOST também hospeda, registra o seu domínio, otimiza para o Google e ajuda a atrair clientes com SEO, marketing digital e anúncios — tudo em um só lugar."
        links={[
          { label: "Hospedagem", to: "/hospedagem" },
          { label: "VPS", to: "/vps" },
          { label: "Domínios", to: "/dominios" },
          { label: "SEO", to: "/solucoes#seo" },
        ]}
      />

      <CriaSiteFinalCta />
    </SiteLayout>
  );
}